function getMessageEncoding(message) {
  let enc = new TextEncoder();
  return enc.encode(message);
}

function bufferToHex(buffer) {
  return Array.from(new Uint8Array(buffer), (byte) => `0${(byte & 0xff).toString(16)}`.slice(-2)).join('');
}

function hexToBuffer(hexString) {
  let byteArray = new Uint8Array(hexString.length / 2);
  for (let i = 0; i < hexString.length; i += 2) {
    byteArray[i / 2] = parseInt(hexString.substr(i, 2), 16);
  }
  return byteArray.buffer;
}

function importSecretKey(key) {
  const rawKey = getMessageEncoding(key);
  return window.crypto.subtle.importKey('raw', rawKey, 'AES-GCM', false, ['encrypt', 'decrypt']);
}

async function encryptMessage(message, key) {
  const iv = window.crypto.getRandomValues(new Uint8Array(12));
  const symmetricKey = await importSecretKey(key);
  let ciphertext = await window.crypto.subtle.encrypt(
    {
      name: 'AES-GCM',
      iv,
      tagLength: 128,
    },
    symmetricKey,
    getMessageEncoding(message)
  );
  const decryptedBytes = new Uint8Array(ciphertext);
  return bufferToHex(Uint8Array.from([...iv, ...decryptedBytes]));
}

async function decryptMessage(encryptContent, key) {
  const symmetricKey = await importSecretKey(key);
  const contentBuffer = hexToBuffer(encryptContent);
  const contentBytes = new Uint8Array(contentBuffer);
  const ivBytes = contentBytes.slice(0, 12);
  const decryptedBuffer = await window.crypto.subtle.decrypt(
    {
      name: 'AES-GCM',
      iv: ivBytes,
      tagLength: 128,
    },
    symmetricKey,
    contentBytes.slice(12, contentBytes.length)
  );
  const decryptedBytes = new Uint8Array(decryptedBuffer);
  const enc = new TextDecoder('utf-8');
  return enc.decode(decryptedBytes);
}

export default { encryptMessage, decryptMessage };
